export const SUPPORT_FULL_STATE_SCHEMA = 'app-guincho-support-full-state/v1' as const;
export const SUPPORT_FULL_STATE_MAX_PART_BYTES = 4 * 1024 * 1024;
export const SUPPORT_FULL_STATE_PLAN_BATCH_SIZE = 256;

export type SupportFullStateRow = Readonly<Record<string, unknown>>;

export interface SupportFullStateMediaSource {
  mediaId: string;
  sourceUri: string;
  contentType: string;
  checklistId: string | null;
  fieldId: string | null;
  origin: { table: string; rowId: string | null; checklistId: string | null; fieldId: string | null; path: string | null };
}

export interface SupportFullStateSnapshot {
  tables: Readonly<Record<string, readonly SupportFullStateRow[]>>;
  media: readonly SupportFullStateMediaSource[];
}

export interface SupportFullStatePart {
  ordinal: number;
  sha512: string;
  byteLength: number;
  mime: 'application/x-ndjson' | 'application/json' | 'application/octet-stream' | 'image/jpeg' | 'image/png' | 'image/webp' | 'application/pdf';
  kind: 'row' | 'row_fragment' | 'media' | 'media_fragment' | 'media_unavailable';
  logical: Record<string, unknown>;
  read(): Promise<Uint8Array>;
}

export interface SupportFullStateManifest {
  schema: typeof SUPPORT_FULL_STATE_SCHEMA;
  generatedAt: string;
  exportId: string;
  requestId: string;
  tableCounts: Record<string, number>;
  identity: { empresaId: string; userId: string; deviceId: string };
  client: { appVersion: string; build: number; platform: string; syncStatus: string; lastSyncAt: number | null };
  logicalPartCount: number;
  mimeTypes: string[];
  kinds: string[];
  /** [ordinal, sha512, bytes, mimeIndex, kindIndex, metadados] */
  parts: Array<[number, string, number, number, number, Record<string, unknown>]>;
}
